const { makeStyles } = require('@material-ui/core')

export const applicationsStyles = makeStyles(theme => ({
   formContainerStyles: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
      margin: '0 auto 10px'
   },

   formControl: {
      width: '100%',
      textAlign: 'initial',
      fontSize: 14,
      '&:not(:first-child)': {
         marginTop: 20
      }
   },
   helperText: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      fontSize: 11
   },
   formControlTextArea: {
      width: '100%',
      textAlign: 'initial',
      fontSize: 14,
      '&:not(:first-child)': {
         marginTop: 20
      }
   },
   button: {
      width: '140px',
      height: 40,
      marginTop: 20,
      color: 'white',
      background: '#3264DC'
   },
   formCleanButton: {
      color: '#3264DC',
      border: '1px solid #3264DC',
      fontWeight: 'bold',
      marginTop: 20,
      width: '140px'
   },
   titleOne: {
      margin: '20px 0 15px 9px',
      fontStyle: 'normal',
      fontSize: 14,
      alignSelf: 'start',
      color: '#8A8FAB',
      fontWeight: 400
   },

   containerButtonSubmit: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%'
   },

   // dropzone
   modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,.5)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3),
      maxWidth: '550px'
   },
   confirmModalContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1.6rem 3rem',
      gap: '1rem',
      paddingBottom: '5rem'
   },
   iconContainer: {
      alignSelf: 'center',
      marginBottom: 16
   },
   warningIcon: {
      color: '#fe6320',
      fontSize: 68
   },

   containerIconImage: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
   },

   uploadImage: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      borderRadius: '0px',
      border: '1px solid #8A8FAB8D',
      borderRadius: '4px',
      padding: '10px',
      color: '#8A8FAB',
      marginTop: '10px',
      '&:hover': {
         cursor: 'pointer',
         backgroundColor: 'none',
         borderRadius: '4px'
      }
   },
   uploadImage2: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      borderRadius: '0px',
      border: '1px solid #f44336',
      borderRadius: '4px',
      padding: '10px',
      color: '#8A8FAB',
      marginTop: '10px',
      '&:hover': {
         cursor: 'pointer',
         backgroundColor: 'none',
         borderRadius: '4px'
      }
   },
   imageText: {
      color: '#8A8FAB'
   },

   imageText2: {
      color: '#f44336'
   },
   errorImg: {
      color: '#f44336',
      fontSize: '11px',
      marginTop: '1px'
   },

   iconImage: {
      fontSize: 24
   },

   // modal
   modalContainer: {
      backgroundColor: '#F9FAFC',
      width: '45%',
      right: 0,
      float: 'right',
      position: 'absolute',
      borderRadius: 0
   },

   uploadIconModal: {
      backgroundColor: '#FFFFFF',
      color: '#43496A',
      width: '150px',
      height: '150px',
      marginBottom: '20px',
      '&:hover': {
         cursor: 'pointer'
      }
   },

   modalContent: {
      backgroundColor: '#F9FAFC',
      height: '100vh',
      borderRadius: 0
   },

   dropZoneAreaModal: {
      paddingTop: '45%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center'
   },

   topBoxModal: {
      position: 'absolute',
      width: '100%',
      top: '20px',
      marginRight: '20px',
      display: 'flex',
      justifyContent: 'center'
   },

   topBoxContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '95%',
      borderBottom: '1px solid #A1A4B5'
   },

   closeIcon: {
      marginRight: 10,
      marginTop: -1,
      color: '#B1B5C8',
      '& span': { color: '#3264DC', fontWeight: 600 },
      '&:hover': {
         cursor: 'pointer'
      }
   },

   spanTitleIcon: {
      display: 'block',
      color: '#43496A',
      fontWeight: '500',
      fontSize: '18px'
   },
   spanIconClick: {
      borderBottom: '1px solid #43496A',
      cursor: 'pointer'
   },

   containerMainPdf: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '50px'
   },

   containerPdf: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '5px 20px'
   },

   containerIconPdf: {
      marginLeft: '20px'
   },

   iconPdf: {
      backgroundColor: '#6161610D',
      borderRadius: '9999px',
      padding: '8px 13px',
      cursor: 'pointer'
   },

   pdfName: {
      textAlign: 'left',
      marginLeft: '20px',
      fontWeight: '700'
   },

   pdfDate: {
      textAlign: 'left',
      marginLeft: '20px',
      marginTop: '-10px'
   },
   iconRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   iconText: {
      marginLeft: theme.spacing(1)
   },
   buttonImage: {
      cursor: 'pointer',
      color: '#8A8FAB',
      borderBottom: '1px solid blue'
   },

   containerModal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },

   containerPaper: {
      backgroundColor: 'white',
      boxShadow: theme.shadows[5],
      boxShadow: '0 3px 4px -1px #d1d5db',
      borderRadius: '0.275rem',
      position: 'relative'
   },
   containerIcon: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      cursor: 'pointer'
   },

   containerImg: {
      padding: '100px'
   }
}))
